<template>
  <div>
    <b-navbar tag="header" fixed="top" type="dark" variant="primary">
      <span class="navbar-brand">
        <img class="nav-icon" src="./../assets/appicon11.png" title="meta.overflow.control" />
      </span>
      <h1 class="navbar-brand mb-0 mx-auto">meta.overflow.control</h1>
      <b-navbar-nav>
        <b-nav-form>
          <b-button size="sm" variant="success" title="Add Overflow Screen" @click="addScreen()">
            <b-icon-plus font-scale="1.5"></b-icon-plus>
          </b-button>
        </b-nav-form>
      </b-navbar-nav>
    </b-navbar>
    <b-container tag="main" fluid>
      <b-jumbotron v-show="countScreens === 0" header="Overflow Control" lead="No screens defined.">
        <b-button variant="success" @click="addScreen()">
          <b-icon-plus></b-icon-plus>Add screen
        </b-button>
      </b-jumbotron>
      <b-row class="row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4">
        <div class="col" v-for="screen in screens" :key="screen.id">
          <div class="card mb-4">
            <img
              v-if="screen.channel"
              :src="getThumbByChannelTitle(screen.channel)"
              class="card-img-top"
              @click="openChannelSelector(screen)"
            />
            <div
              v-if="!screen.channel"
              class="bg-warning position-relative"
              style="padding-bottom: calc(100%/(1280/464))"
              @click="openChannelSelector(screen)"
            >
              <div
                class="position-absolute d-flex justify-content-center align-items-center"
                style="top:0;right:0;bottom:0;left:0"
              >
                <h4 class="text-white">
                  <b-icon-alert-triangle-fill></b-icon-alert-triangle-fill> No source selected
                </h4>
              </div>
            </div>
            <div class="card-body">
              <h4>
                <span v-show="!screen.edit" @click="toggleEdit(this, screen)">
                  {{ screen.title }}
                  <b-icon-pencil></b-icon-pencil>
                </span>
              </h4>
              <input
                type="text"
                v-model="screen.title"
                v-show="screen.edit"
                @blur="saveEdit(ev, screen)"
              />
              <b-icon-check v-show="screen.edit"></b-icon-check>
              <h6 @click="openChannelSelector(screen)">
                Source: {{ screen.channel ? screen.channel : "none" }}
                <!-- <b-button
                  pill
                  size="sm"
                  class="float-right"
                  @click="openChannelSelector(screen)"
                  ><b-icon-pencil></b-icon-pencil
                ></b-button>-->
              </h6>
            </div>
            <div class="btn-group" role="group">
              <router-link v-if="screen.channel" :to="'/overflow/' + screen.title + '/' + screen.channel + '/' + getIdByChannelTitle(screen.channel)" class="btn btn-success" title="Preview" target="_blank">
                <b-icon-eye font-scale="1.5"></b-icon-eye>
              </router-link>
              <button
                :id="'url-' + screen.id"
                type="button"
                class="btn btn-secondary"
                title="Copy URL"
              >
                <b-icon-code font-scale="1.5"></b-icon-code>
              </button>
              <button
                type="button"
                class="btn btn-danger"
                title="Delete"
                @click="deleteScreen(screen.id)"
              >
                <b-icon-trash font-scale="1.5"></b-icon-trash>
              </button>
              <b-tooltip
                :target="'url-' + screen.id"
                :title="'https://overflow-control-uat.meta-fusion.com/overflow/' + screen.title + '/' + screen.channel + '/' + getIdByChannelTitle(screen.channel)"
                triggers="focus"
              ></b-tooltip>
            </div>
          </div>
        </div>
      </b-row>
    </b-container>
    <div>
      <b-modal id="channelSelector" title="Select source channel" ok-disabled>
        <b-card
          v-for="ch in channels"
          :key="ch.id"
          :title="ch.title"
          :bg-variant="ch.title === modal.selectedChannel ? 'success' : ''"
          :text-variant="ch.title === modal.selectedChannel ? 'white' : ''"
          :img-src="getThumbById(ch.id)"
          img-alt="Image"
          img-top
          tag="article"
          class="mb-4"
          @click="setChannel(ch.title)"
        ></b-card>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      screens: [
        // {
        //   title: "Entrance Screen",
        //   channel: "Channel A",
        //   edit: false
        // },
        // {
        //   title: "Overflow Area 1",
        //   channel: "Channel A",
        //   edit: false
        // },
        // {
        //   title: "Overflow Area 2",
        //   channel: "Channel B",
        //   edit: false
        // },
        // {
        //   title: "Overflow Area 3",
        //   channel: "Channel C",
        //   edit: false
        // },
        // {
        //   title: "Backoffice",
        //   channel: "",
        //   edit: false
        // },
        // {
        //   title: "Buffet screen",
        //   channel: "Channel A",
        //   edit: false
        // }
      ],
      channels: [
        {
          id: 61675,
          title: 'Channel A'
        },
        {
          id: 62004,
          title: 'Channel B'
        },
        {
          id: 62003,
          title: 'Channel C'
        },
        {
          id: 59437,
          title: 'Channel D'
        },
        {
          id: 62565,
          title: 'Channel E'
        },
        {
          id: 59406,
          title: 'Channel F'
        },
        {
          id: 59385,
          title: 'Channel G'
        },
        {
          id: 59410,
          title: 'Channel H'
        }
      ],
      modal: {
        selectedScreen: null,
        selectedChannel: ''
      },
      currentScreenId: 0
    }
  },

  computed: {
    countScreens: function () {
      return this.screens.length
    }
  },

  methods: {
    addScreen () {
      this.screens.push({
        id: this.currentScreenId,
        title: 'Untitled',
        channel: '',
        edit: false
      })
      this.currentScreenId++
    },

    openChannelSelector (screen) {
      this.modal.selectedScreen = screen.id
      this.modal.selectedChannel = screen.channel
      this.$bvModal.show('channelSelector')
    },

    setChannel (title) {
      let i = this.screens.findIndex(s => s.id === this.modal.selectedScreen)
      this.screens[i].channel = title
      this.$bvModal.hide('channelSelector')
      this.modal.selectedScreen = ''
      this.modal.selectedChannel = ''
    },

    deleteScreen (id) {
      this.$bvModal
        .msgBoxConfirm('Are you sure?', {
          size: 'sm',
          buttonSize: 'sm',
          title: 'Delete Screen?',
          headerBgVariant: 'danger',
          headerTextVariant: 'light'
        })
        .then(value => {
          if (value) {
            let i = this.screens.findIndex(s => s.id === id)
            this.screens.splice(i, 1)
          }
        })
    },

    toggleEdit: function (ev, screen) {
      screen.edit = !screen.edit

      // Focus input field
      if (screen.edit) {
        this.nextTick(function () {
          ev.$$.input.focus()
        })
      }
    },

    saveEdit: function (ev, screen) {
      // save your changes
      this.toggleEdit(ev, screen)
    },
    getIdByChannelTitle (title) {
      if (title) {
        let ch = this.channels.find(c => c.title === title)
        return ch.id
      }
      return ''
    },
    getThumbByChannelTitle (title) {
      let ch = this.channels.find(c => c.title === title)
      return this.getThumbById(ch.id)
    },
    getThumbById (id) {
      return (
        '//d544i1zeqmmnk.cloudfront.net/i/wcm/190531_6176_ESA_Euroanaesthesia2019_Vienna/thumbn/congressresource_' +
        id +
        '.jpg?w=320'
      )
    }
  }
}
</script>

<style lang="scss">
header {
  min-height: 42px;

  .navbar-brand {
    display: inline-flex;
  }
  .navbar-text {
    padding: 0.3125rem 0 0.375rem;
  }
  .nav-icon {
    width: 24px;
    height: 24px;
  }
}

main {
  margin-top: 42px;
  padding: 15px;
}

img {
  cursor: pointer;
}

.tooltip-inner {
  max-width: 280px;
}
</style>
